export const productMenu = {
	all: "Todos os produtos",
	activedProducts: "Produtos ativos",
	inactivedProducts: "Produtos desativados",
	isDisabledMenu: "Cardápios principais não podem ser editados ou excluídos",
	legacyMenuTag: "Legado",
	legacyMenuTooltip: "Este cardápio é da versão anterior e não pode mais ser editado.",
	defaultMenuName: "Cardápio Principal",
	tooltipActive: "Cardápio ativo",
	tooltipInactive: "Cardápio desativado",
	tooltipMenuType: "Tipo do cardápio",
	info: {
		product: "produto",
		products: "produtos",
	},
	manageMenu: "Gestão de cardápios",
	manageBars: "Bares",
	manageProducts: "Gestão de produtos",
	newMenu: "Novo cardápio",
	createNewMenu:
		"Crie, edite e gerencie cardápios com status, ativando ou inativando conforme a demanda.",
	requiredField: "Campo Obrigatório",
	menuName: "Nome do cardápio duplicado",
	duplicateMenu: "Duplicar Cardápio",
	editMenu: "Editar Cardápio",
	closeAction: "Fechar",
	addProducts: "Adicionar Produtos",
	newMenuName: "Nome do Cardápio",
	duplicateMenuError:
		"Já existe um cardápio deste tipo ativo. Só pode existir um cardápio ativo por tipo.",
	menus: "Cardápios",
	status: "Status",
	type: "Tipo",
	createFirstMenu: "Crie seu primeiro cardápio agora",
	createMenuInstructions:
		"Crie agora o seu primeiro cardápio e vincule produtos e preços.",
	createMenu: "Criar Cardápio",
	duplicate: "Duplicar",
	delete: "Excluir",
	edit: "Editar",
	deleteMenu: "Excluir Cardápio",
	confirmDelete:
		"Deseja excluir o {{menuName}}? Todas as informações serão excluídas e essa ação não poderá ser desfeita.",
	active: "Ativo",
	inactive: "Inativo",
	confirmDuplicateMenu:
		"Deseja duplicar {{menuName}}? Todas as informações da réplica serão idênticas ao original, mas não estarão vinculadas a nenhuma área.",
	menuType: {
		normal: "Normal",
		delivery: "Delivery",
		dineIn: "Pedido na mesa",
		hawker: "Ambulante",
		grabAndGo: "Grab and Go",
		onlineFicha: "Ficha Digital",
		pickUp: "Retirada",
		deliveryByMarketplace: "Entrega pelo restaurante",
		onlineTab: "Comanda online",
		viewMenu: "Cardápio digital",
		deliveryIntegrated: "Delivery Integrado",
		digital: "Cardápio Digital",
	},
	activateMenu: "Ativar Cardápio",
	deactivateMenu: "Desativar Cardápio",
	importProducts: "A partir de importação de produtos",
	importWithSheet: "Utilize planilha para importar novos produtos automaticamente",
	linkExistingProducts: "Vincular produtos existentes",
	selectImportedProducts:
		"Selecione produtos já importados para vinculá-los ao novo cardápio",
	importCategoriesProducts:
		"Serão importados e criados categorias e produtos. Caso o produto já exista, ele será duplicado nessa importação.",
	emptyText: {
		title: "Ainda não tem nada por aqui",
		description: "Comece vinculando categorias, e depois os produtos ao cardápio.",
	},
	menuTypeLabel: "Tipo de Cardápio",
	downloadSampleSheet: "Clique aqui para baixar a planilha de exemplo",
	clickToAddSheet: "Clique para adicionar planilha",
	importSheet: "Importar Planilha",
	importProductsTitle: "Importar Produtos",
	emptyRowsWarning: "Sua planilha contém linhas vazias",
	linkProductsToMenu: "Vincular produtos ao cardápio",
	noProductFound: "Nenhum produto encontrado",
	enterNewMenuName: "Digite o nome do novo cardápio",
	selectMenuType: "Selecione o tipo do cardápio",
	addProductsCount: "Adicionar {{products}} produtos",
	selectProductsToLink: "Selecione os produtos que deseja vincular ao novo cardápio",
	loadingProducts: "Carregando produtos",
	fileLoadError:
		"Não conseguimos carregar o seu arquivo. Por favor, confirme se o arquivo foi salvo corretamente e tente novamente",
	loadingSheet: "Carregando planilha",
	invalidRowsError: "Linhas inválidas, verifique as seguintes colunas: {{rows}}",
	linkProductToMenu: "Vincular produto",
	createProduct: "Criar Produto",
	confirmRemoveProdutFromMenu:
		"Deseja desvincular {{productName}} do cardápio? Caso existam informações editadas de preço, você as perderá. Se quiser apenas desativar o produto do cardápio, você pode clicar na chave do status na tabela dos produtos do cardápio.",
	removeProductFromMenu: "Desvincular produto do cardápio",
	confirmRemoveProductFromMenuLabel: "Desvincular produto",
	revertProductPriceTitle: "Desfazer alteração de preço",
	confirmRevertProductPriceDescription:
		"Ao confirmar essa ação, você voltará ao preço do produto, descartando a alteração feita previamente. O preço do produto são os preços definidos na seção 'Gestão de Produto'.",
	editProductTitle: "Editar {{productName}}",
	category: "Categoria",
	price: "Preço",
	saveChanges: "Salvar Alterações",
	editMenuProduct: "Editar produto no cardápio",
	yes: "Sim",
	no: "Não",
	positivePriceErrorMessage: "O preço deve ser um valor positivo",
	viewProductPage: "Ver Página do Produto",
	product: "Produto",
	mountable: "Montável",
	searchProduct: "Buscar Produto",
	importWithSheetToMenu:
		"Utilize planilha para importar novos produtos automaticamente para o cardápio",
	createProductFromScratch: "Criar produto do zero",
	createNewProduct: "Crie um novo produto preenchendo todos os dados necessários",
	selectProductsToLinkToMenu: "Selecione os produtos que deseja vincular ao cardápio",
	addProductsToMenu: "Adicione produtos ao cardápio",
	emptyMenu: "Cardápio vazio",
	addProductsToStartUsingIt: "Adicione produtos para começar a usar",
	sku: "SKU",
	nameMaxLength: "Limite de {{maxLength}} caracteres excedido",
	menuCreated: "Cardápio criado com sucesso",
	menuUpdated: "Cardápio editado com sucesso",
	menuRemoved: "Cardápio removido com sucesso",
	menuDuplicated: "Cardápio duplicado",
	menuStatusChanged: "Status do cardápio alterado",
	menuProductPriceChanged:
		"O preço do {{productName}} foi alterado com sucesso no {{menuName}}",
	menuProductUpdated:
		"O produto {{productName}} foi atualizado com sucesso no {{menuName}}",
	menuProductRemoved:
		"O produto {{productName}} foi removido com sucesso do {{menuName}}",
	productsAmountAtMenu: "qtd. de produtos",
	products: "produto(s)",
	allCategories: "Todas as categorias",
	filters: {
		all: "Todos",
		filterByName: "Filtrar por nome",
		filterByMenuType: "Filtrar por tipo de cardápio",
		allMenuTypes: "Todos os tipos",
		filterByLinkedBars: "Filtrar por bares vinculados",
		activeFilters: "Filtros ativos",
		clearAll: "Limpar todos os filtros",
		noResults: "Nenhum resultado encontrado com os filtros atuais",
		clearFilters: "Limpar filtros",
	},
	createMenuModal: {
		menuNameLabel: "Nome do cardápio",
		menuNamePlaceholder: "Nomeie o cardápio",
		title: "Adicionar cardápio",
	},
	editMenuModal: {
		title: "Editar cardápio",
	},
	bars: "Bares",
	barsByVendor: {
		vendorsLabel: "Vendors",
		otherBarsLabel: "Outros bares",
		summary: "{{total}} bares · {{selected}} selecionados",
	},
	dashboard: {
		productCount: "Qtd. de produtos",
		categoryCount: "Categorias",
		barCount: "Bares",
	},
	linkProductsDrawer: {
		categories: "Categorias",
		itemsSelected: "itens selecionados",
		newlySelected: "Selecionado",
		alreadyAdded: "Adicionado",
		addAllProducts: "Adicionar Todos Produtos",
		linkProducts: "Vincular produtos",
		title: "Víncular produtos",
		successMessage: "Produto(s) vinculado ao cardápio com sucesso",
		typeToSearch: "Digite para pesquisar",
		noProductFound: "Nenhum produto encontrado",
		product: "Produto",
		sku: "SKU",
		closeAction: "Fechar",
		saveChanges: "Salvar Alterações",
		selectProductsToLinkToMenu: "Selecione os produtos que deseja vincular ao cardápio",
		searchProduct: "Buscar Produto",
		organizedBy: "Organizado por",
		categoryOfProduct: "Categoria do produto",
		searchCategories: "Buscar categorias",
		productsFromAllCategories: "PRODUTOS DE TODAS AS CATEGORIAS",
		productsFromSelectedCategory: "PRODUTOS DA CATEGORIA SELECIONADA",
		searchProducts: "Buscar produto",
		selectAllItemsFromCategory: "Selecionar todos os itens da categoria",
		loadingProducts: "Carregando produtos...",
		noProductsFound: "Nenhum produto encontrado",
		products: "Produtos",
		withoutCategory: "Sem categoria",
	},
	allowFichaExport: "Permitir exportação de fichas",
	menuConfig: {
		sidebarHeader: "Configurações de Cardápio",
		sidebar: {
			general: {
				title: "Configuração Geral",
				description: "Habilite e configure as funcionalidades do seu cardápio digital.",
			},
			branding: {
				title: "Identidade Visual",
				description: "Personalize as cores, o logo e o banner deste cardápio.",
			},
			layout: {
				title: "Layout das Categorias",
				description: "Escolha como as categorias serão exibidas no cardápio.",
			},
			banners: {
				title: "Banners de Campanha",
				description: "Crie e ordene os banners exibidos neste cardápio.",
			},
			featured: {
				title: "Seção de Destaque",
				description: "Escolha os produtos em destaque deste cardápio.",
			},
			qrcode: {
				title: "QR Code e Link",
				description: "Copie o link e gere o QR Code dos seus cardápios ativos",
			},
		},
		sidebarGroups: {
			appearance: "Aparência",
			content: "Conteúdo",
			access: "Acesso",
		},
		operationModeSection: {
			title: "Modo de operação",
			description: "Escolha o modo de operação do cardápio digital.",
		},
		modes: {
			vitrine: {
				title: "Modo Vitrine",
				description: "Permite que os clientes apenas visualizem o cardápio",
			},
			posPago: {
				title: "Modo Pós Pago",
				description: "Permite que os clientes paguem no próprio cardápio após o pedido.",
			},
			prePago: {
				title: "Modo Pré Pago",
				description: "Permite que os clientes paguem para fazer o pedido.",
			},
		},
		defaultTag: "Padrão",
		saveButton: "Salvar configurações",
		saving: "Salvando...",
		saveSuccess: "Configuração salva com sucesso",
		saveError: "Não foi possível salvar a configuração",
		brandingSection: {
			title: "Identidade Visual",
			description: "Personalize a aparência deste cardápio para os seus clientes.",
			fields: {
				name: "Nome de exibição",
				logo: "Logo",
				banner: "Capa",
				primaryColor: "Cor primária",
			},
			namePlaceholder: "Nome exibido no cardápio",
			saveButton: "Salvar identidade visual",
			saving: "Salvando...",
			saveSuccess: "Identidade visual salva com sucesso",
			saveError: "Não foi possível salvar a identidade visual",
		},
		layoutSection: {
			title: "Layout das Categorias",
			description: "Escolha como as categorias serão exibidas no cardápio.",
			defaultTag: "Padrão",
			options: {
				tags: {
					title: "Etiquetas",
					description: "Exibe as categorias como uma lista de etiquetas roláveis.",
				},
				cards: {
					title: "Cards",
					description: "Exibe as categorias como cards com imagem em destaque.",
				},
			},
			saveButton: "Salvar layout",
			saving: "Salvando...",
			saveSuccess: "Layout salvo com sucesso",
			saveError: "Não foi possível salvar o layout",
		},
	},
};
